module.exports = __webpack_public_path__ + "static/media/01A.34b5468e.png";